const VALID_ORIGIN_REGEX = /^https?:\/\/[^/]+$/;
const ORIGIN_REGEX = /^https?:\/\/[^/]+/;

/**
 * Returns the request URL based on the frontend application origin. This is necessary because
 * the nuxt application is unable to determine the origin. Normally the x-forwarded-host header
 * can be used, but using an environment variable is more reliable.
 *
 * @returns The current request URL
 */
export function useNloRequestURL(): ReturnType<typeof useRequestURL> {
	const runtimeConfig = useRuntimeConfig();
	let requestURL = useRequestURL();

	const origin = runtimeConfig.public.commonBaseUrl;

	if (origin !== null && typeof origin === 'string' && VALID_ORIGIN_REGEX.test(origin)) {
		requestURL = new URL(requestURL.toString().replace(ORIGIN_REGEX, ''), origin);
	}

	return requestURL;
}
